module.exports = __webpack_public_path__ + "cancellara-dist/img/promoshopping.8ef165e1.png";